import React, { useState } from "react";

const Search = ({ onSearch, placeholder }) => {
  const [search, setSearch] = useState("");

  const onInputChange = (value) => {
    setSearch(value);
    onSearch(value);
  };
  return (
    <div className="form-group col-lg-5">
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        required
        name="search"
        value={search}
        onChange={(e) => onInputChange(e.target.value)}
      />
    </div>
  );
};

export default Search;
